<template>
  <div>
    <div>
      <FilterCard :applied-filter-count="appliedFilterCount">

        <b-row>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Order Date"
              label-for="order-date"
            >
              <div class="position-relative">
                <AdvancedDateFilter
                  :date-value="filters['orders.created_at']"
                  :opens="'right'"
                  :clear-icon="true"
                  @update="updateDateRange('orders.created_at', $event)"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Received Date"
              label-for="received-date"
            >
              <div class="position-relative">
                <AdvancedDateFilter
                  :date-value="filters['order_order_flags.created_at']"
                  :opens="'right'"
                  :clear-icon="true"
                  @update="updateDateRange('order_order_flags.created_at', $event)"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Destination Warehouse"
              label-for="destination-warehouse"
            >
              <v-select
                v-model="filters['destination_warehouse_id']"
                :options="warehouseOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Warehouse"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Temporary Warehouse"
              label-for="temporary-warehouse"
            >
              <v-select
                v-model="filters['temporary_warehouse_id']"
                :options="warehouseOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Warehouse"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
    </div>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
            >
              <div>
                <ReportTableButtons
                  :items="items"
                  :json_fieldz="json_fields"
                  :name="`${downloadReportName} - Page ${page}.xls`"
                  :bulkname="`${downloadReportName}.xls`"
                  :fetch="fetchDataForTemporaryWarehouseNoPagination"
                  @refresh="fetchDataForTemporaryWarehouse"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :json_fields="json_fields"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
            sticky-header="100vh"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #cell(order_date)="data">
              {{ __dateTimeFormatter(data.value) }}
            </template>
            <template #cell(status_change_date)="data">
              {{ __dateTimeFormatter(data.value) }}
            </template>
            <template #cell(customer_phone)="data">
              <div>{{ data.item.customer_phone }}</div>
              <div v-if="data.item.customer_secondary_phone">
                {{ data.item.customer_secondary_phone }}
              </div>
            </template>
            <template #cell(cod_amount)="data">
              {{ __numberWithCommas(data.value, true) }}
            </template>
            <template #cell(merchant_data)="data">
              {{ data.item.merchant_data && data.item.merchant_data.name ? data.item.merchant_data.name : '' }}
            </template>
            <template #cell(destination_warehouse)="data">
              {{ data.item.destination_warehouse && data.item.destination_warehouse.name ? data.item.destination_warehouse.name : '' }}
            </template>
            <template #cell(temporary_warehouse)="data">
              {{ data.item.temporary_warehouse && data.item.temporary_warehouse.name ? data.item.temporary_warehouse.name : '' }}
            </template>
            <template #cell(order_current_status)="data">
              {{ data.item.order_current_status && data.item.order_current_status.name ? data.item.order_current_status.name : '' }}
            </template>
          </b-table>
        </b-overlay>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-sm-start"
            >
              <label class="mr-1">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block width-125"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              md="9"
              class="d-flex align-items-center justify-content-sm-end"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BPagination,
} from 'bootstrap-vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/ReportFilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import getWarehouseList from './WarehouseListDropdown'
import { Tablefields } from './TableFields'

const ReportRepository = RepositoryFactory.get('report')

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    FilterCard,
    vSelect,
    AdvancedDateFilter,
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BOverlay,
    BPagination,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      warehouseOptions: [],
      filters: {
        'orders.created_at': {
          startDate: null,
          endDate: null,
        },
        'order_order_flags.created_at': {
          startDate: null,
          endDate: null,
        },
      },
      tableData: [],
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200, 500],
      totalRows: 1,
      page: 1,
      meta: {},
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: Tablefields,
      json_fields: {
        'Order Date': {
          field: 'order_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Received Date': {
          field: 'status_change_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Waybill Number': 'waybill_number',
        Merchant: {
          callback: value => `"${value.merchant_data && value.merchant_data.name ? value.merchant_data.name : ''}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`,
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        'Destination Warehouse': {
          callback: value => `"${value.destination_warehouse && value.destination_warehouse.name ? value.destination_warehouse.name : ''}"`,
        },
        'Temporary Warehouse': {
          callback: value => `"${value.temporary_warehouse && value.temporary_warehouse.name ? value.temporary_warehouse.name : ''}"`,
        },
        Weight: 'weight',
        COD: 'cod_amount',
        Status: {
          callback: value => `"${value.order_current_status && value.order_current_status.name ? value.order_current_status.name : ''}"`,
        },
      },
      downloadReportName: 'Temporary-Warehouse-Report',
      currentDate: '',
      todayFilterQuery: '',
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    page() {
      this.fetchDataForTemporaryWarehouse()
    },
    perPage() {
      this.fetchDataForTemporaryWarehouse()
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.setTodayFilter()
    this.fetchDataForTemporaryWarehouse()
    this.warehouseList()
    this.updateFilterCount()
  },
  methods: {
    async fetchDataForTemporaryWarehouse() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await ReportRepository.getTemporaryWarehouseReport(this.page, filterQuery, this.perPage))
        // filter the default date or selected date for table data and meta data
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchDataForTemporaryWarehouseNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await ReportRepository.getTemporaryWarehouseReportNoPagination(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async warehouseList() {
      this.warehouseOptions = await getWarehouseList()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForTemporaryWarehouse()
    },
    setTodayFilter() {
      const currentDate = this.todayFilter()
      this.updateDateRange('orders.created_at', currentDate)
      this.updateDateRange('order_order_flags.created_at', currentDate)
    },
    applyFilters() {
      this.fetchDataForTemporaryWarehouse()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        'orders.created_at': {
          startDate: null,
          endDate: null,
        },
        'order_order_flags.created_at': {
          startDate: null,
          endDate: null,
        },
      }
      this.setTodayFilter()
      this.$nextTick(() => {
        this.fetchDataForTemporaryWarehouse()
      })
      this.updateFilterCount()
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select';
</style>
